package com.milta.feature.team.domain.usecase

import com.milta.feature.team.domain.entity.Enterprise
import com.milta.feature.team.domain.repository.TeamRepository

class GetMyEnterpriseUseCase(private val repository: TeamRepository) {
    suspend operator fun invoke(): Result<Enterprise> = repository.getMyEnterprise()
}
